export default __webpack_public_path__ + "static/media/testmunk.f965d800.svg";